import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import { FormattedField, TextField, TextareaField } from '../../common';

export default function PharmacyRecords({
  values,
  getHandler,
  errors,
  pharmacyRecords,
}) {
  const { properties } = pharmacyRecords;
  return (
    <div className="chats">
      {properties?.previous_dental_records && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.previous_dental_records?.description ||
                'How would you like TrueLark to respond if a patient asks whether they can bring X-rays or reports from their previous dentist?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={values.previous_dental_records || ''}
                name="previous_dental_records"
                onChange={getHandler}
                error={errors.previous_dental_records}
              />
            </div>
          </div>
        </>
      )}
      {properties?.share_dental_records && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.share_dental_records?.description ||
                'How would you like TrueLark to respond if a patient requests to have their X-rays sent to another provider or individual?'}
            </p>
          </div>
          <div className="chats__row" style={{ textAlign: 'right' }}>
            <div className="chats__row__input chat-textarea">
              <div>
                <TextareaField
                  count
                  max={160}
                  value={values.share_dental_records || ''}
                  name="share_dental_records"
                  onChange={getHandler}
                  error={errors.share_dental_records}
                />
              </div>
            </div>
          </div>
        </>
      )}
      {properties?.patient_articles && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.patient_articles?.description ||
                'How would you like TrueLark to respond if a patient asks whether their dentures, Invisalign, or braces have arrived?'}
            </p>
          </div>
          <div className="chats__row" style={{ textAlign: 'right' }}>
            <div className="chats__row__input chat-textarea">
              <div>
                <TextareaField
                  count
                  max={160}
                  value={values.patient_articles || ''}
                  name="patient_articles"
                  onChange={getHandler}
                  error={errors.patient_articles}
                />
              </div>
            </div>
          </div>
        </>
      )}
      {properties?.share_patient_prescription && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.share_patient_prescription?.description ||
                'How would you like TrueLark to respond if a patient wants a prescription sent to the pharmacy?'}
            </p>
          </div>
          <div className="chats__row" style={{ textAlign: 'right' }}>
            <div className="chats__row__input chat-textarea">
              <div>
                <TextareaField
                  count
                  max={160}
                  value={values.share_patient_prescription || ''}
                  name="share_patient_prescription"
                  onChange={getHandler}
                  error={errors.share_patient_prescription}
                />
              </div>
            </div>
          </div>
        </>
      )}
      {properties?.patient_prescription_recommendation && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.patient_prescription_recommendation?.description ||
                'How would you like TrueLark to respond if a patient has questions about their prescription, including dosage, or recommendations for a replacement?'}
            </p>
          </div>
          <div className="chats__row" style={{ textAlign: 'right' }}>
            <div className="chats__row__input chat-textarea">
              <div>
                <TextareaField
                  count
                  max={160}
                  value={values.patient_prescription_recommendation || ''}
                  name="patient_prescription_recommendation"
                  onChange={getHandler}
                  error={errors.patient_prescription_recommendation}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

PharmacyRecords.defaultProps = {
  getHandler: () => {},
  values: {},
  errors: {},
};

PharmacyRecords.propTypes = {
  getHandler: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
};
